/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx, propsUtils } from '@ba-ui-toolkit/utils';
import DecoratorStyles from './Decorator.scss';

const decoratorClassName = DecoratorStyles.decoratorClassName.replace(/"/g, '');
const decorationClassName = DecoratorStyles.decorationClassName.replace(/"/g, '');
const { sanitize } = propsUtils;

export default class Decorator extends Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		style: PropTypes.object,
		className: PropTypes.string,
	};
	static defaultProps = {
		style: {},
		className: '',
	};
	render() {
		const { style, className, ...others } = this.props;

		return (
			<span
				{...sanitize(others, Decorator)}
				className={`${decoratorClassName} ${className}`}
				style={style}
			>
				{this.props.children}
			</span>
		);
	}
}

export class Decoration extends Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		location: PropTypes.oneOf([
			'left',
			'right',
			'top',
			'bottom',
			'topLeft',
			'topRight',
			'bottomLeft',
			'bottomRight',
			'point',
		]),
		x: PropTypes.number,
		y: PropTypes.number,
		style: PropTypes.object,
	};

	static defaultProps = {
		location: 'bottomRight',
		style: {},
	};

	render() {
		const { location, style, ...others } = this.props;
		let styles;
		if (location === 'point') {
			styles = {
				left: this.props.x,
				top: this.props.y,
				...style,
			};
		}

		return (
			<div
				{...sanitize(others, Decoration)}
				className={cx(decorationClassName, { [this.props.location]: 1 })}
				style={styles}
			>
				{this.props.children}
			</div>
		);
	}
}
